/** Masques téléphone par pays (react-input-mask) */
export const phoneFormats = {
	France: { mask: '+33 9 99 99 99 99', placeholder: 'Exemple : +33 6 12 34 56 78' },
	Belgique: { mask: '+32 9 999 99 99', placeholder: 'Exemple : +32 478 12 34 56' },
	Luxembourg: { mask: '+352 999 999 999', placeholder: 'Exemple : +352 621 123 456' },
	Suisse: { mask: '+41 99 999 99 99', placeholder: 'Exemple : +41 79 123 45 67' },
	Allemagne: { mask: '+49 9999 9999999', placeholder: 'Exemple : +49 151 23456789' },
	Espagne: { mask: '+34 999 99 99 99', placeholder: 'Exemple : +34 612 34 56 78' },
	Italie: { mask: '+39 999 999 9999', placeholder: 'Exemple : +39 347 123 4567' },
	Portugal: { mask: '+351 999 999 999', placeholder: 'Exemple : +351 912 345 678' },
	'Pays-Bas': { mask: '+31 99 999 9999', placeholder: 'Exemple : +31 6 1234 5678' },
	Irlande: { mask: '+353 99 999 9999', placeholder: 'Exemple : +353 86 123 4567' },
	Autriche: { mask: '+43 999 9999999', placeholder: 'Exemple : +43 660 1234567' },
	Danemark: { mask: '+45 99 99 99 99', placeholder: 'Exemple : +45 20 12 34 56' },
	Suède: { mask: '+46 99 999 99 99', placeholder: 'Exemple : +46 70 123 45 67' },
	Finlande: { mask: '+358 99 999 9999', placeholder: 'Exemple : +358 40 123 4567' },
	Grèce: { mask: '+30 999 999 9999', placeholder: 'Exemple : +30 691 234 5678' },
	Pologne: { mask: '+48 999 999 999', placeholder: 'Exemple : +48 601 234 567' },
	Hongrie: { mask: '+36 99 999 9999', placeholder: 'Exemple : +36 30 123 4567' },
	Tchéquie: { mask: '+420 999 999 999', placeholder: 'Exemple : +420 602 123 456' },
	Slovaquie: { mask: '+421 999 999 999', placeholder: 'Exemple : +421 905 123 456' },
	Slovénie: { mask: '+386 99 999 999', placeholder: 'Exemple : +386 41 234 567' },
	Roumanie: { mask: '+40 999 999 999', placeholder: 'Exemple : +40 721 234 567' },
	Bulgarie: { mask: '+359 999 999 999', placeholder: 'Exemple : +359 88 123 4567' },
	Estonie: { mask: '+372 9999 9999', placeholder: 'Exemple : +372 512 3456' },
	Lettonie: { mask: '+371 9999 9999', placeholder: 'Exemple : +371 291 23456' },
	Lituanie: { mask: '+370 999 99999', placeholder: 'Exemple : +370 612 34567' },
	Croatie: { mask: '+385 99 999 9999', placeholder: 'Exemple : +385 91 123 4567' },
	Malte: { mask: '+356 9999 9999', placeholder: 'Exemple : +356 9912 3456' },
	Chypre: { mask: '+357 99 999999', placeholder: 'Exemple : +357 96 123456' },
	'République tchèque': { mask: '+420 999 999 999', placeholder: 'Exemple : +420 602 123 456' },
};
